import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BabyBoyIcon = createIcon({
  displayName: 'BabyBoyIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M15.889 11.994l1.94473e-08-2.53352e-08c-.279242.363786-.708502.581175-1.167.591l7.31749e-08 2.00705e-09c-.457533-.0125492-.885382-.229409-1.166-.591"></path>
        <path d="M10.444 11.994l-1.46502e-08 1.90864e-08c-.279024.363516-.707856.580874-1.166.591l-5.20738e-08-1.40957e-09c-.457852-.0123935-.88607-.229255-1.167-.591"></path>
        <path d="M12 21.474l1.32862e-07-6.9921e-11c3.75415-.00197568 7.04299-2.51519 8.031-6.137l6.41474e-08-7.12298e-09c1.21309-.134703 2.0873-1.22731 1.9526-2.4404 -.114087-1.02744-.925164-1.83851-1.9526-1.9526l2.85903e-07 1.05072e-06c-1.20689-4.4354-5.78086-7.05263-10.2163-5.84574 -2.84699.774676-5.07106 2.99875-5.84574 5.84574l5.67171e-09-6.29791e-10c-1.21309.134703-2.0873 1.22731-1.9526 2.4404 .114087 1.02744.925164 1.83851 1.9526 1.9526l2.74695e-07 1.00697e-06c.988006 3.62181 4.27685 6.13502 8.031 6.137Z"></path>
        <path d="M14.222 16.147l6.30406e-08-5.4997e-08c-1.27314 1.11069-3.17086 1.11069-4.444 1.46263e-07"></path>
        <path d="M9.719 2.526l-9.97057e-08 2.66454e-15c1.25976-5.50659e-08 2.281 1.02124 2.281 2.281"></path>
        <path d="M12 4.807l2.4869e-14 3.44421e-07c-1.90219e-07-1.25976 1.02124-2.281 2.281-2.281"></path>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const BabyBoy: FC<IconProps> = (props) => {
  return <CustomIcon as={BabyBoyIcon} {...props} />
}

export default memo(BabyBoy)
